import React from 'react';

export const menuCanBeDisplayed = (enablingConditions: any[], values: any) => {
  if (enablingConditions && values) {
    let mustBeDisplayed = false;
    enablingConditions.forEach((cond) => {
      let valueOfDependantComponent;
      if (cond.componentId && cond.condition) {
        valueOfDependantComponent = values[cond.componentId];
        if (cond.componentId && cond.condition && cond.condition.substr(0, 1) === '>') {
          if (!Number.isNaN(valueOfDependantComponent)) {
            mustBeDisplayed = parseInt(valueOfDependantComponent, 10) > parseInt(cond.condition.substr(1).trim(), 10);
          } else {
            mustBeDisplayed = false;
          }
        } else {
          // equals
          mustBeDisplayed = mustBeDisplayed || valueOfDependantComponent === cond.condition;
        }
      } else {
        // enabling conditions for checkboxes example (boolean): [s1,s2,s3] or [depositary,ta]
        valueOfDependantComponent = values[cond];
        mustBeDisplayed = mustBeDisplayed || valueOfDependantComponent === true;
      }
    });
    return mustBeDisplayed;
  }
  return false;
};

export const canBeDisplayed = (
  enablingConditions: any[],
  isDisplayed: boolean,
  setIsDisplayed: (displayed: boolean) => void,
  values: any,
  rowPrefix: string
) => {
  if (enablingConditions) {
    let mustBeDisplayed = true;
    enablingConditions.forEach((cond) => {
      if (mustBeDisplayed) {
        let valueOfDependantComponent;

        if (rowPrefix && cond.componentId.substr(0, 1) === 'C') {
          valueOfDependantComponent = values[rowPrefix + cond.componentId];
        } else {
          valueOfDependantComponent = values[cond.componentId];
        }

        if (cond.componentId && cond.condition && cond.condition.substr(0, 1) === '>') {
          if (!Number.isNaN(valueOfDependantComponent)) {
            mustBeDisplayed = parseInt(valueOfDependantComponent, 10) > parseInt(cond.condition.substr(1).trim(), 10);
          } else {
            mustBeDisplayed = false;
          }
        } else {
          mustBeDisplayed = valueOfDependantComponent === cond.condition;
        }
      }
    });
    if (mustBeDisplayed !== isDisplayed) {
      setIsDisplayed(mustBeDisplayed);
    }
    return mustBeDisplayed;
  }
  return true;
};

export const emptyField = (
  field: any,
  setFieldValue: (name: string, add: string) => void,
  rowPrefix: string,
  isDisabled: boolean,
  isDisplayed: boolean,
  enablingConditions: any[],
  touched: any
) => {
  // When the component is not displayed its value must be empty
  if (!isDisabled && !isDisplayed) {
    let parentIsTouched = false;
    enablingConditions.forEach((cond) => {
      let valueOfDependantComponent;
      if (cond.componentId.substr(0, 1) === 'C') {
        valueOfDependantComponent = rowPrefix + cond.componentId;
      } else {
        valueOfDependantComponent = cond.componentId;
      }
      if (touched[valueOfDependantComponent]) {
        parentIsTouched = true;
      }
    });
    if (parentIsTouched) {
      setFieldValue(field.name, '');
    }
  }
};

export const mustBeFilled = (
  enablingConditions: any[],
  isDisplayed: boolean,
  setIsDisplayed: (displayed: boolean) => void,
  values: any,
  rowPrefix: string,
  required: boolean,
  showRequiredFields: boolean
) => {
  return canBeDisplayed(enablingConditions, isDisplayed, setIsDisplayed, values, rowPrefix) && required && showRequiredFields;
};

export const fieldIsEmpty = (values: any, fieldName: string) => {
  return !values || !values[fieldName] || values[fieldName].toString().trim() === '';
};

export const getHighlightedText = (text: string, highlight: string) => {
  if (highlight) {
    // Split on highlight term and include term into parts, ignore case
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return (
      <span>
        {parts.map((part, i) => (
          <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { fontWeight: 'bold', textDecoration: 'underline' } : {}}>
            {part}
          </span>
        ))}
      </span>
    );
  }
  return <span>{text}</span>;
};
